import { interfaces } from '@jarvis/shell-commons';
import { PromiseReturnType } from './typeHandlers';
import { MfePropsType } from './mfeProps';
import { TranslatorFunctionResourcePropType } from '@jarvis/shell-commons/dist/services/localizationService/types';

export type InterfacesType = Omit<typeof interfaces, '_shell'>;

export type TranslatorFunctionType = PromiseReturnType<
  InterfacesType['v1']['localization']['createTranslatorFunction']
>;

export enum Stack {
  dev,
  pie,
  stage,
  prod
}

export enum ApplicationContext {
  NATIVE_APP = 'NATIVE_APP',
  NATIVE_PORTAL = 'NATIVE_PORTAL',
  WEB_PORTAL = 'WEB_PORTAL'
}

export type ShellProps = {
  interfaces: InterfacesType;
};

export type ShellRootComponentProps = {
  onMount?: () => void;
  onUnmount?: () => void;
  localizationResources?: TranslatorFunctionResourcePropType;
} & MfePropsType;
